import { randUuid } from "@/libraries/helper";
import { AuthPasswordSchema } from "@/schemas";
import CheckCircle from "@mui/icons-material/CheckCircle";
import CircleOutlined from "@mui/icons-material/CircleOutlined";
import { memo, useMemo } from "react";

interface PasswordValidationRuleType {
	isChecked: boolean;
	text: string;
}

interface PasswordValidationProps {
	value: string;
}

const passwordValidationRule = [
	{
		isChecked: true,
		text: "Minimum 9 characters",
	},
	{
		isChecked: false,
		text: "Contains at least 1 lowercase character",
	},
	{
		isChecked: false,
		text: "Contains at least 1 uppercase character",
	},
	{
		isChecked: false,
		text: "Contains at least 1 digit",
	},
	{
		isChecked: false,
		text: "Contains at least 1 special character",
	},
];

const PasswordValidationItem = ({
	isChecked,
	text,
}: PasswordValidationRuleType) => {
	const Icon = useMemo(
		() => (isChecked ? CheckCircle : CircleOutlined),
		[isChecked],
	);
	return (
		<div className="w-full flex flex-row gap-2 items-center justify-start">
			<Icon color={isChecked ? "success" : "disabled"} />
			<p
				className={`text-sm ${isChecked ? "text-[#2e7d32]" : "text-zinc-950"}`}
			>
				{text}
			</p>
		</div>
	);
};

const CreatePasswordValidation = (props: PasswordValidationProps) => {
	const { value } = props;
	const validateValue = AuthPasswordSchema.safeParse(value);

	const rules = useMemo(() => {
		return passwordValidationRule.map((rule) => ({
			...rule,
			isChecked: !validateValue.error?.issues?.some(
				(issue) => issue.message.toLowerCase() === rule.text.toLowerCase(),
			),
		}));
	}, [validateValue]);

	return (
		<div className="w-full flex flex-col gap-1">
			{rules.map((rule) => (
				<PasswordValidationItem key={randUuid()} {...rule} />
			))}
		</div>
	);
};

export default memo(CreatePasswordValidation);
